var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"msg-box"},[_c('h1',{staticClass:"animated fadeInDown"},[_vm._v("404 Not Found")]),_c('h2',{staticClass:"animated fadeInUp"},[_vm._v("\n\t\t\tOops!"),_c('br'),_vm._v("It seems that this page does not exist.\n\t\t")])])])
}]

export { render, staticRenderFns }